<template>
  <div class="container mt-5">
    <div>
    <h1>
      <b-icon icon="people-fill"></b-icon> Show Requests

      
         <div class="float-right" style="margin-top: -62px;"> <b-button v-b-modal.modal-help v-b-tooltip.hover title="Help" class="help"> <b-icon icon="question-square-fill" ></b-icon> Help</b-button> 
       </div>
         <help id="15" />
    </h1>

    </div>
   
    
    <div class="clearfix"></div>


        <div class="filter mb-3 mt-3 text-center">

          <button type="button" class="btn btn-light mr-3"   @click="$bvModal.hide('modal-lg'), filterCourseStatus()" 
               
             > All </button> 


              <button type="button" class="btn btn-success mr-3"   @click="$bvModal.hide('modal-lg'), filterCourseStatus('Approved')" 
               
             >Approved </button>             

              <button type="button" class="btn btn-customeInfo mr-3"   @click="$bvModal.hide('modal-lg'), filterCourseStatus('Pending')">
                
                Pending</button>

              <button type="button" class="btn btn-danger"  @click="$bvModal.hide('modal-lg'), filterCourseStatus('Declined')">
                Rejected</button> 


        </div>
   
    <div class="">
      <div class="row">
        <div class="col-sm-12" v-if="isLoading">
          <div class="text-center">
            <b-spinner variant="primary" label="Text Centered"></b-spinner>
          </div>
        </div>

        <!-- <b-card  class="col-md-12 col-sm-12 select mb-5" border-variant="primary" sm="12"  v-if="emptyFound">
                       No Data Found
                  </b-card> -->

        <b-card
          class="col-md-12 col-sm-12 select mb-5"
          border-variant="warning"
          sm="12"
          v-if="empty & !isLoading"
        >
          {{ message }}
        </b-card>

        <div 
          v-for="(request, index) of result"
          :key="index"
          class="col-md-4 col-sm-12 mb-5"
          border-variant="primary"
        >
        
          <div class=" card p-4">
            <b-card-text
              ><strong
                >Course Code :
                <span class="customeP">{{ request.CourseCode }} </span>
              </strong>
            </b-card-text>
            <b-card-text
              ><strong
                >Course Name :
                <span class="customeP">{{ request.CourseNameEN }} </span>
              </strong>
            </b-card-text>
            <b-card-text
              >
              <strong
                >Course Status :
                <b-badge
                  v-if="request.CourseStatus == 'Approved'"
                  variant="success"
                  >Approved</b-badge
                >
                <b-badge
                  v-else-if="request.CourseStatus == 'Declined'"
                  variant="danger"
                  >Rejected</b-badge
                >
                <b-badge
                  v-else-if="request.CourseStatus == 'Pending'"
                  variant="info"
                  >Pending</b-badge
                >
                <b-badge v-else variant="warning">---</b-badge>
              </strong></b-card-text
            >

            <div class="text-center" v-if="request.CourseStatus == ''">
              <b-button
                class="subButton"
                @click="InsertRequestCourse(request.serial)"
              >
                Request
              </b-button>
            </div>

            <div class="text-center" v-else>
              <b-button class="subButton">
                <b-icon icon="check-circle-fill" aria-hidden="true"></b-icon>
              </b-button>
            </div>

            <div class="clearfix"></div>
          </div>
        </div>
      </div>
   
      <div class="col-sm-12 text-right mb-5 mt-5">
        <button
          class="btn btn-primary "
          @click="() => $router.push('/Adviser')"
        >
          Back to advisor
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import ShowRequest from "../../../services/academic/StudentAdvicessServices";
import Help from '../../Help.vue';

export default {
  components: { Help },
  name: "Co-advisor",
  data() {
    return {
      ShowRequest: [],
      InsertRequest: "",
      isLoading: true,
      empty: true,

      message: "",
      CourseStatusFilter: '', 
      result : []
    };
  },
  computed: {
    currenUser() {
      return this.$store.state.auth.user;
    },
    
  },
  mounted() {
    this.RequestCoursesSelect();
  },
  methods: {
    RequestCoursesSelect() {
      // eslint-disable-next-line no-debugger
      ShowRequest.StudentRequestCoursesSelect(this.currenUser.StudentID,"", "").then(
        (Response) => {
          this.isLoading = false;
          this.ShowRequest = Response.data;
          this.result = this.ShowRequest
          this.empty = false;

          // eslint-disable-next-line no-console
         // console.log(this.result.length + " Length")
          // this.emptyFound = false;

          if (this.ShowRequest.length == 0) {
            this.message = "No Data Found!";
            this.empty = true;
            return true;
          }
          // eslint-disable-next-line no-console
          //console.log(this.ShowRequest)
        },
        (error) => {
          // eslint-disable-next-line no-console
          // console.log(error.response.status)
          this.empty = true;
          // this.emptyFound = true;
          this.isLoading = false;
          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.Message) ||
            error.message ||
            error.toString();

          if (error.response.status == 404) this.message = "No Data Found!";
        }
      );
    },

    InsertRequestCourse(crsID) {
      this.isLoading = true;

      ShowRequest.StudentInsertRequestCourse(
        this.currenUser.StudentID,
        crsID
      ).then(
        (Response) => {
          this.isLoading = false;
          this.empty = false;
          //  this.emptyFound= false;
          this.InsertRequest = Response.data;

          this.RequestCoursesSelect();
        },
        (error) => {
          // eslint-disable-next-line no-console
          // console.log(error.response.status)
          this.empty = true;
          // this.emptyFound = true;
          this.isLoading = false;
          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.Message) ||
            error.message ||
            error.toString();

          if (error.response.status == 404)
            this.message =
              "The course already added by the student, Check student Request!";
          if (error.response.status == 400)
            this.message = "The Course already added and declined!";
        }
      );
    },

    filterCourseStatus(status){

// eslint-disable-next-line no-debugger
 this.empty = false;

    
        if(!status )
        {
          this.result = this.ShowRequest;
           if (this.result.length == 0) {
            this.message = "No Data Found!";
            this.empty = true;            
          }
          return this.result;
        }
        
      else if(status == 'Approved'){
        //return this.CourseStatusFilter = 'Approved';
         this.result = this.ShowRequest.filter(c=> c.CourseStatus == 'Approved');
           if (this.result.length == 0) {
            this.message = "No Data Found!";
            this.empty = true;            
          }
          
          return  this.result;
      }
      else if(status == 'Pending'){
        //return this.CourseStatusFilter = 'Pending';
          this.result = this.ShowRequest.filter(c=> c.CourseStatus == 'Pending');
           if (this.result.length == 0) {
            this.message = "No Data Found!";
            this.empty = true;            
          }
       
          return  this.result;
      }
      else{
        //return this.CourseStatusFilter = 'Declined';
          this.result = this.ShowRequest.filter(c=> c.CourseStatus == 'Declined');
          if (this.result.length == 0) {
            this.message = "No Data Found!";
            this.empty = true;            
          }
         // eslint-disable-next-line no-console
         // console.log( this.result.length + " Length");
          return  this.result;
      }
    }
  },
};
</script>

<style scoped>
.help {
  color: #fff;
  background-color: #ff8600;
  /* padding: 2px 16px; */
}
h1 {
  color: #285475;
  font-size: 25px;
  border-bottom: 1px #646464 dashed;
  padding: 10px 0px;
}
h1 a {
  color: #ff8600;
}

.btn-info {
  color: #fff;
  background-color: #eef6fb;
  border-color: rgb(178 188 198 / 25%);
  color: #1e5b8b !important;
  padding: 1em 2em !important;
  text-align: left;
  width: 100%;
  font-weight: 800;
}

.btn-info:hover {
  color: #fff !important;
  background-color: #285475;
  border-color: #204866;
}

.btn-info.focus,
.btn-info:focus {
  color: #1e5b8b !important;
  background-color: #eef6fb;
  border-color: #204866;
}
.subButton {
  margin-bottom: -50px;
  width: 50%;
  background: #285476;
  text-align: center;
  border: 0px;
}

.customeP {
  /* white-space: nowrap; */
  font-weight: 100;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}

.btn-customeInfo{
    color: #fff;
    background-color: #17a2b8;
    border-color: #17a2b8;
}
</style>
